import Api from "@/services/Api";

export default {
  getFonts() {
    return Api().get("fonts");
  },

  get(id) {
    return Api().get('fonts/' + id)
  },
  create(payload) {
    return Api().post('fonts', payload)
  },
  update(id, payload) {
    return Api().put('fonts/' + id, payload)
  },
  delete(id) {
    return Api().delete('fonts/' + id)
  },

  upload(formData) {
    return Api().post("fonts/upload", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};